import {Injectable} from '@angular/core';
import {NavFactory} from './nav.factory';
import {NavItemCodes} from '../../enums/nav-item-codes.enum';
import {PermissionArea} from '../../enums/permission-area.enum';
import {IconCode} from '../../enums/icon-code.enum';

@Injectable()
export class NavPolicyFactory extends NavFactory {
    protected static basePolicyRegistryPath = '/policy-registry';
    protected static items = [
        {
            code: NavItemCodes.POLICY_REGISTRY,
            icon: IconCode.POLICY_REGISTRY,
            label: 'NAV.POLICY_REGISTRY.LABEL',
            description: 'NAV.POLICY_REGISTRY.DESC',
            path: NavPolicyFactory.basePolicyRegistryPath,
            permissionArea: PermissionArea.POLICY_REGISTRY
        },
        {
            code: NavItemCodes.POLICY_LABEL_SHORT,
            icon: IconCode.POLICY_REGISTRY,
            label: 'NAV.POLICY_REGISTRY.LABEL_SHORT',
            path: NavPolicyFactory.basePolicyRegistryPath,
            permissionArea: PermissionArea.POLICY_REGISTRY
        },
        {
            code: NavItemCodes.POLICY_PREVIEW,
            icon: IconCode.POLICY_PREVIEW,
            label: 'LABELS.PREVIEW',
            description: '',
            path: (transcoderId) => [NavPolicyFactory.basePolicyRegistryPath, transcoderId],
            permissionArea: PermissionArea.POLICY_REGISTRY,
        },
        {
            code: NavItemCodes.POLICY_PG,
            icon: IconCode.POLICY_PG,
            label: 'NAV.POLICY_PG.LABEL',
            description: '',
            path: ({policyId}) => [NavPolicyFactory.basePolicyRegistryPath, 'pg', policyId],
            permissionArea: PermissionArea.POLICY_REGISTRY,
        },
        {
            code: NavItemCodes.POLICY_CPI,
            label: 'NAV.POLICY_CPI.LABEL',
            icon: IconCode.POLICY_CPI,
            path: ({policyId}) => [NavPolicyFactory.basePolicyRegistryPath, 'cpi', policyId],
            permissionArea: PermissionArea.SALES_CPI,
        },
    ];
}
